export const GET_MAP_REPORT_METRICS = 'GET_MAP_REPORT_METRICS';
export const GET_PATCHING_REPORT_METRICS = 'GET_PATCHING_REPORT_METRICS';
export const GET_BACKUPS_REPORT_METRICS = 'GET_BACKUPS_REPORT_METRICS';
export const GET_EC2_REGIONS_REPORT_METRICS = 'GET_EC2_REGIONS_REPORT_METRICS';
export const GET_EC2_VPC_REPORT_METRICS = 'GET_EC2_VPC_REPORT_METRICS';